export enum SexE {
  Male = 'Male',
  Female = 'Female',
}
